
const LigneAchatCollection = function(element) {
    this.element = $(element);
    this.add = this.element.find('[data-add-line]');
    this.tbody = this.element.find('table tbody');
    this.tfoot   = this.element.find('table tfoot');
    this.fournisseur = this.element.closest('form').find('[name$="\[fournisseur\]"]');

    this.add.on('form-success.modal', (event, response) => {
        let row = this.initRow();
        this.updateRow(row, response);
    });

    this.tbody.on('before-load.modal', '[data-edit]', (event, requestData) => {
        this.setEditData($(event.currentTarget).closest('tr'), requestData)
    });
    this.tbody.on('form-success.modal', '[data-edit]', (event, response) => {
        this.updateRow($(event.currentTarget).closest('tr'), response);
    });

    this.tbody.on('click', '[data-delete]', event => {
        $(event.currentTarget).closest('tr').remove();
    });

    /// Mise à jour donnée dans le tableau
    this.tbody.on('keyup change', '[name$="[quantiteUnitaire]"], [name$="[prixUnitaire]"]', event => {
        this.updateRowTotalHT($(event.currentTarget).closest('tr'));
    });
    this.tbody.on('keyup change', '[name$="[totalTVA]"]', event => {
        this.updateRowTotalTTC($(event.currentTarget).closest('tr'));
    });

    this.tbody.on('change', '[name$="[uniteVente]"]', event => {
        this.updateUniteVente($(event.currentTarget).closest('tr'));
    });
    this.tbody.on('keyup change', '[name$="[quantite]"]', event => {
        this.updateRowPrixKG($(event.currentTarget).closest('tr'));
    });

    /// Mise à jour TVA fournisseur
    this.fournisseur.on('change', () => {
        this.tbody.find('tr').each((index, row) => {
            this.updateRowTotalTVA($(row));
        });
    });

    /// Fix calculs initiaux (validation échouée)
    this.tbody.find('tr').each((index, element) => {
        var row = $(element);

        if (row.find('[name$="\[totalHT\]"]').val() == '') {
            this.updateRowTotalHT(row);
        }
    })
};

$.extend(LigneAchatCollection.prototype, {
    initRow: function() {
        let prototype = this.element.attr('data-prototype'),
            name = 0;

        // Find max name
        this.element.find('[data-name]').each(function() {
            let n = parseInt($(this).attr('data-name'));

            if (n >= name) {
                name = n + 1;
            }
        });

        prototype = prototype.replace(/__name__/g, name);

        return $(prototype).appendTo(this.tbody);
    },

    isTVA0: function() {
        const option = this.fournisseur.find(':selected');

        return option.attr('data-tva0') === '1';
    },

    updateUniteVente: function(row) {
        const uniteVente = row.find('[name$="\[uniteVente\]"]').val();
        const isKGS = uniteVente === 'KGS';

        row.attr('data-ligne-kgs', isKGS ? '1' : '0');

        if (isKGS) {
            row.find('[name$="\[quantite\]"]').formatMoney(row.find('[name$="\[quantiteUnitaire\]"]').parseMoney());
            // row.find('[name$="\[prixUnitaire\]"]').formatMoney(row.find('[name$="\[prix\]"]').parseMoney());
        }

        this.updateRowPrixKG(row);
    },

    updateRowPrixKG: function(row) {
        const uniteVente = row.find('[name$="\[uniteVente\]"]').val();
        const isKGS = uniteVente === 'KGS';
        const totalHT = row.find('[name$="\[totalHT\]"]').parseMoney();

        let prix;

        if (isKGS) {
            prix = row.find('[name$="\[prixUnitaire\]"]').parseMoney();
        } else {
            prix = totalHT / row.find('[name$="\[quantite\]"]').parseFloat();
        }

        row.find('[name$="\[prix\]"]').formatMoney(prix);
    },

    updateRow: function(row, data) {
        let prixUnitaire = data.prixUnitaire / 100,
            quantiteUnitaire = data.quantiteUnitaire,
            quantite = data.quantite,
            prix = data.prix / 100
        ;

        row.attr('data-ligne-kgs', data.isKGS ? '1' : '0');

        row.find('[data-designation]').text(data.designation);

        row.find('[name$="\[famille\]"]').val(data.famille.id);
        row.find('[name$="\[origine\]"]').val(data.origine ? data.origine.id : '');
        row.find('[name$="\[calibre\]"]').val(data.calibre ? data.calibre.id : '');
        row.find('[name$="\[variete\]"]').val(data.variete ? data.variete.id : '');
        row.find('[name$="\[qualite\]"]').val(data.qualite ? data.qualite.id : '');

        row.find('[name$="\[ratioQuantitePoids\]"]').val(data.ratioQuantitePoids);
        row.find('[name$="\[quantiteUnitaire\]"]').val(quantiteUnitaire);
        row.find('[name$="\[quantite\]"]').val(quantite);

        row.find('[name$="\[prixUnitaire\]"]').formatMoney(prixUnitaire);
        row.find('[name$="\[prix\]"]').formatMoney(prix);

        row.find('[name$="\[uniteVente\]"]').val(data.uniteVente);

        row.find('[name$="\[tauxTVA\]"]').val(data.tauxTVA);

        this.updateRowTotalHT(row);
    },

    updateRowTotalHT: function(row) {
        let quantiteUnitaire = row.find('[name$="\[quantiteUnitaire\]"]').parseFloat(),
            prixUnitaire = row.find('[name$="\[prixUnitaire\]"]').parseMoney(),
            totalHT = prixUnitaire * quantiteUnitaire;

        row.find('[name$="\[totalHT\]"]').formatMoney(totalHT);

        // Refresh quantite KGS if line is KGS
        if (row.attr('data-ligne-kgs') === '1') {
            row.find('[name$="\[quantite\]"]').val(quantiteUnitaire);
            row.find('[name$="\[prix\]"]').val(prixUnitaire);
        }

        this.updateRowPrixKG(row);
        this.updateRowTotalTVA(row);
    },

    updateRowTotalTVA: function(row) {
        let totalHT = row.find('[name$="\[totalHT\]"]').parseMoney(),
            tauxTVA = row.find('[name$="\[tauxTVA\]"]').parseFloat(),
            totalTVA = this.isTVA0() ? 0 : (Math.round(totalHT * tauxTVA * 100) / 100);

        row.find('[name$="\[totalTVA\]"]').formatMoney(totalTVA);

        this.updateRowTotalTTC(row);
    },

    updateRowTotalTTC: function(row) {
        let totalHT = row.find('[name$="\[totalHT\]"]').parseMoney(),
            totalTVA = row.find('[name$="\[totalTVA\]"]').parseMoney(),
            totalTTC = totalHT + totalTVA;

        row.find('[name$="\[totalTTC\]"]').formatMoney(totalTTC);

        this.updateTotalFooter();
    },

    updateTotalFooter: function() {
        let totalHT = 0, totalTVA = 0, totalTTC = 0;

        this.tbody.find('tr').each(function() {
            const $tr = $(this);

            totalHT  += $tr.find('[name$="\[totalHT\]"]').parseMoney();
            totalTVA  += $tr.find('[name$="\[totalTVA\]"]').parseMoney();
            totalTTC += $tr.find('[name$="\[totalTTC\]"]').parseMoney();
        });

        this.tfoot.find('[data-total-ht]').formatMoney(totalHT);
        this.tfoot.find('[data-total-tva]').formatMoney(totalTVA);
        this.tfoot.find('[data-total-ttc]').formatMoney(totalTTC);
    },

    setEditData: function(row, requestData) {
        requestData.famille = row.find('[name$="\[famille\]"]').val();
        requestData.origine = row.find('[name$="\[origine\]"]').val();
        requestData.calibre = row.find('[name$="\[calibre\]"]').val();
        requestData.variete = row.find('[name$="\[variete\]"]').val();
        requestData.qualite = row.find('[name$="\[qualite\]"]').val();
        requestData.designation = row.find('[name$="\[designation\]"]').val();
        requestData.quantiteUnitaire = row.find('[name$="\[quantiteUnitaire\]"]').val();
        requestData.prixUnitaire = row.find('[name$="\[prixUnitaire\]"]').parseFloat() * 100;
    }
});

const ligneAchatCollection = () => {
    $(document).arrive('[data-ligne-achat-collection]', {
        existing: true
    }, function() {
        new LigneAchatCollection(this);
    });
};

export { ligneAchatCollection }


// WEBPACK FOOTER //
// ./js/form/ligneAchatCollection.js